import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './AtBiyanis.css';

const AtBiyanis = () => {
  const icseToppers = [
    { name: "Manthan Shah", rank: "Rank 2", school: "KVIS", percentage: "99.40%", year: 2025 },
    { name: "Prisha Shah", rank: "Rank 2", school: "KVIS", percentage: "99.40%", year: 2025 },
    { name: "Prateek Saraf", rank: "Rank 1", school: "RBK", percentage: "99.40%", year: 2025 },
    { name: "Ridhimaan Sil", rank: "Rank 1", school: "GHS", percentage: "99.20%", year: 2025 },
    { name: "Harshad Gowda", rank: "Rank 1", school: "EURO THANE", percentage: "98.60%", year: 2025 },
    { name: "Yash Patel", rank: "Rank 1", school: "AP INTERNATIONAL", percentage: "97.00%", year: 2025 },
    { name: "Ananya Chauhan", rank: "Rank 1", school: "DALMIA", percentage: "99.00%", year: 2025 },
    { name: "Lanie Jain", rank: "Rank 2", school: "DALMIA", percentage: "98.80%", year: 2025 },
    { name: "Ranveer Singh", rank: "Rank 3", school: "DALMIA", percentage: "98.60%", year: 2025 },
    { name: "Taranjyot Kaur", rank: "Rank 1 COMMERCE", school: "RBK", percentage: "95.61%", year: 2025 },
    { name: "Chaitanya Mundra", rank: "Rank 2", school: "TPS", percentage: "98.80%", year: 2025 },
    { name: "Taniska Iyangar", rank: "Rank 1", school: "RIS", percentage: "97.00%", year: 2025 },
    { name: "Aditi Agarwal", rank: "Rank 3", school: "RBK", percentage: "98.80%", year: 2020 },
    { name: "Paree Dubey", rank: "Rank 3", school: "RBK", percentage: "98.40%", year: 2020 },
    { name: "Neel Parmar", rank: "Rank 3", school: "RBK", percentage: "98.40%", year: 2020 },
    { name: "Prakhar Mundra", rank: "Rank 3", school: "RBK", percentage: "98.20%", year: 2019 },
    { name: "Asavari", rank: "Rank 3", school: "RBK", percentage: "98.20%", year: 2019 },
    { name: "Meghana Agarwal", rank: "Rank 3", school: "RBK", percentage: "98.80%", year: 2024 },
    { name: "Asmi Patange", rank: "Rank 3", school: "UNIVERSAL", percentage: "97.60%", year: 2024 },
    { name: "Shreya Yadav", rank: "Rank 1", school: "RBK", percentage: "99.20%", year: 2021 },
    { name: "Divyansh Agarwal", rank: "Rank 3", school: "RBK", percentage: "98.60%", year: 2021 },
    { name: "Komal Singh", rank: "Rank 1", school: "TPS", percentage: "98.00%", year: 2021 },
    { name: "Ishan Duraphe", rank: "Rank 1", school: "TPS", percentage: "99.20%", year: 2022 },
    { name: "Sarah Sagri", rank: "Rank 1", school: "RBK", percentage: "99.00%", year: 2022 },
    { name: "Sachit Singh", rank: "Rank 1", school: "RBK", percentage: "99.00%", year: 2023 },
    { name: "Shivansh Goyal", rank: "Rank 1", school: "RBK", percentage: "99.00%", year: 2023 },
    { name: "Maanya Master", rank: "Rank 1", school: "LHS", percentage: "99.00%", year: 2023 },
    { name: "Hardik Rathi", rank: "Rank 1", school: "TPS", percentage: "98.80%", year: 2023 },
    { name: "Mitul Chourasia", rank: "Rank 1", school: "AP INTERNATIONAL", percentage: "98.60%", year: 2023 },
    { name: "Suryadatta Sarkar", rank: "Rank 2", school: "GHS", percentage: "98.80%", year: 2023 },
    { name: "Chinmayi Kothawale", rank: "Rank 1", school: "RBK", percentage: "99.20%", year: 2024 },
    { name: "Dhairya Shah", rank: "Rank 1", school: "KVIS", percentage: "99.20%", year: 2024 },
    { name: "Harshit Jadeja", rank: "Rank 1", school: "DALMIA", percentage: "99.20%", year: 2024 },
    { name: "Nisarag Pagaria", rank: "Rank 1", school: "TPS", percentage: "99.00%", year: 2024 },
    { name: "Dhwani Jain", rank: "Rank 1 COMMERCE", school: "RBK", percentage: "98.80%", year: 2024 },
    { name: "Debankita Ghosh", rank: "Rank 1", school: "AP INTERNATIONAL", percentage: "98.60%", year: 2024 },
    { name: "Nivedya Thembari", rank: "Rank 1", school: "AP INTERNATIONAL", percentage: "98.60%", year: 2024 },
    { name: "Aashmi Jain", rank: "Rank 3", school: "KVIS", percentage: "98.60%", year: 2024 },
    { name: "Aayushi Nakar", rank: "Rank 1", school: "LHS", percentage: "98.40%", year: 2024 },
    { name: "Ronit Bandi", rank: "Rank 1 COMMERCE", school: "TPS", percentage: "98.00%", year: 2024 },
    { name: "Sakshi Sarda", rank: "Rank 1 COMMERCE", school: "RBK", percentage: "98.00%", year: 2024 },
    { name: "Jaineel Vora", rank: "Rank 3", school: "KVIS", percentage: "98.40%", year: 2024 },
    { name: "Riti Joshi", rank: "Rank 1", school: "UNIVERSAL", percentage: "98.40%", year: 2024 },
    { name: "Tiya Agarwal", rank: "Rank 1", school: "AP INTERNATIONAL", percentage: "97.40%", year: 2024 },
    { name: "Akshee Jain", rank: "Rank 1 COMMERCE", school: "RBK", percentage: "97.20%", year: 2024 },
    { name: "Vedang Kashyap", rank: "Rank 2", school: "UNIVERSAL", percentage: "97.80%", year: 2024 },
  ];

  const cbseToppers = [
    { name: "Suhani Singh", rank: "Rank 1", school: "RBK G", percentage: "97.60%", year: 2021 },
    { name: "Anoushka Bose", rank: "Rank 2", school: "SSA", percentage: "96.80%", year: 2021 },
    { name: "Nishant Ghosh", rank: "Rank 1", school: "RBK G", percentage: "98.80%", year: 2023 },
    { name: "Krishiv Choumal", rank: "Rank 1", school: "SSA", percentage: "98.80%", year: 2023 },
    { name: "Paakshik Badhatya", rank: "Rank 2", school: "MKVV", percentage: "98.40%", year: 2023 },
    { name: "Hriday Saraf", rank: "Rank 2", school: "RBK G", percentage: "97.80%", year: 2023 },
    { name: "Aryan Murarka", rank: "Rank 1", school: "GGHS", percentage: "98.40%", year: 2024 },
    { name: "Gargee Kanade", rank: "Rank 1", school: "NHSS", percentage: "98.20%", year: 2024 },
    { name: "Shreya Das", rank: "Rank 1", school: "RBK G", percentage: "98.20%", year: 2024 },
    { name: "Durga Shetty", rank: "Rank 1", school: "RBK G", percentage: "98.20%", year: 2024 },
    { name: "Kavya Bachhuka", rank: "Rank 1", school: "SSA", percentage: "98.00%", year: 2024 },
    { name: "Jay Barcha", rank: "Rank 2", school: "SSA", percentage: "97.00%", year: 2024 },
    { name: "Ronish Shah", rank: "Rank 1", school: "TAPOVAN", percentage: "99.00%", year: 2025 },
    { name: "Nikunj Mimani", rank: "Rank 1", school: "RBK G", percentage: "99.00%", year: 2025 },
    { name: "Samarth Ahir", rank: "Rank 1", school: "RBK G", percentage: "99.00%", year: 2025 },
    { name: "Aditri Sultania", rank: "Rank 1", school: "RBK G", percentage: "98.40%", year: 2025 },
    { name: "Archisha Dwivedi", rank: "Rank 2", school: "RBK G", percentage: "98.40%", year: 2025 },
    { name: "Prashant Jha", rank: "Rank 3", school: "RBK G", percentage: "98.00%", year: 2025 },
    { name: "Aditya Verma", rank: "Rank 1", school: "SSA", percentage: "98.40%", year: 2025 },
    { name: "Tanmay Bharadia", rank: "Rank 1", school: "SSA", percentage: "98.40%", year: 2025 },
    { name: "Akshara Tiwari", rank: "Rank 1", school: "SVM", percentage: "96.60%", year: 2025 },
    { name: "Shubhdarshni Tiwari", rank: "Rank 1", school: "SVM", percentage: "96.60%", year: 2025 },
    { name: "Preksha Mishra", rank: "Rank 2", school: "SSA", percentage: "98.20%", year: 2025 },
    { name: "Vaibhav Baldeva", rank: "Rank 2", school: "SSA", percentage: "97.40%", year: 2025 },
    { name: "Arnav", rank: "Rank 2", school: "", percentage: "98.40%", year: 2019 },
    { name: "Varun", rank: "Rank 2", school: "", percentage: "97.40%", year: 2019 },
    { name: "Aryan Murarka", rank: "Rank 1", school: "DPS", percentage: "98.40%", year: 2024 },
    { name: "Nishant Ghosh", rank: "Rank 2", school: "DAV", percentage: "98.80%", year: 2022 },
    { name: "Komal Singh", rank: "Rank 3", school: "Ryan International", percentage: "98.00%", year: 2021 },
    { name: "Arnav Jhawar", rank: "Rank 1", school: "DPS", percentage: "98.20%", year: 2019 },
  ];

  const [bgLoaded, setBgLoaded] = useState(false);
  useEffect(() => {
    const img = new window.Image();
    img.src = '/050A2451.webp';
    img.onload = () => setBgLoaded(true);
  }, []);

  function rankOrder(rank) {
    if (rank.startsWith("Rank 1")) return 1;
    if (rank.startsWith("Rank 2")) return 2;
    if (rank.startsWith("Rank 3")) return 3;
    return 99;
  }

  return (
    <div className="at-biyanis-page">
      <Navbar />
      {/* First Hero Section - About Us */}
      <section
        className="hero-section"
        style={{
          backgroundImage: bgLoaded ? "url('/050A2451.webp')" : 'none',
          backgroundColor: '#e3eaf2',
          opacity: bgLoaded ? 1 : 0.8,
          transition: 'opacity 0.6s ease-in-out',
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>
            <div className="titleContainer">
              <span>ABOUT</span>
              <span>US</span>
            </div>
          </h1>
          <p className="subtitle">Excellence in Education Since 2014</p>
        </div>
      </section>

      <div className="at-biyanis-content">
        {/* About Section with Achievements */}
        <section className="about-section">
          <div className="container">
            <div className="about-content-wrapper">
              <div className="about-text">
            <h2>WELCOME TO BIYANI'S</h2>
            <p>With an experience that spans over 10+ years in teaching, we have an in-depth knowledge of the board & what it takes to excel in ICSE and CBSE With 16+ branches & 2500+ students currently studying at Biyani's Super 30, we are known for our academic planning & conceptual learning. It is this very academic planning, study material, and learning from board specific faculties that has yielded some of the best results in town and produced a Rank 3 in Mumbai for two consecutive years!

Currently teaching students of 15+ Major ICSE Schools of Mumbai including TPS, KVIS, SVIS, Children's Academy, Cambridge, RBK, and others we take pride in the fact that 65% toppers of these schools hail from our institute.</p>
              </div>
              
              <div className="about-video">
                {/* Video Loading State */}
                <div className="video-loading">
                  <div className="loading-spinner"></div>
                  <p>Loading video...</p>
                </div>
                <div className="video-wrapper">
                  <video 
                    controls
                    playsInline
                    className="welcome-video"
                    style={{ opacity: 0 }}
                    onLoadedData={(e) => {
                      e.target.style.opacity = 1;
                      e.target.parentElement.previousElementSibling.style.display = 'none';
                    }}
                  >
                    <source src="/IMG_2798.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
            
            <div className="achievements-grid">
              <div className="achievement-card">
                <h3>10+ Years</h3>
                <p>Of Excellence in Education</p>
              </div>
              <div className="achievement-card">
                <h3>25000+</h3>
                <p>Students</p>
              </div>
              <div className="achievement-card">
                <h3>50+</h3>
                <p>Family of Expert Faculty</p>
              </div>
            </div>
          </div>
        </section>

        {/* Hall of Fame Section */}
        <section className="hall-of-fame-section">
          <div className="container">
            <h2>Beacon Of Achievement</h2>
            <div className="hall-of-fame-container">
              {/* ICSE and CBSE Sections Side by Side */}
              <div className="toppers-grid">
                {/* ICSE Section */}
                <div className="board-section">
                  <div className="board-header">
                    <h3>ICSE</h3>
                    <div className="board-underline"></div>
                  </div>
                  <div className="toppers-list">
                    {icseToppers
                      .sort((a, b) => {
                        if (b.year !== a.year) return b.year - a.year;
                        return rankOrder(a.rank) - rankOrder(b.rank);
                      })
                      .map((student, idx) => (
                        <div className="topper-item" key={student.name + student.year + student.rank + idx}>
                          <span className="student-name" title={student.name}>{student.name}</span>
                          <span className="rank" title={student.rank}>{student.rank}</span>
                          <span className="school" title={student.school}>{student.school}</span>
                          <span className="percentage">{student.percentage}</span>
                          <span className="year">{student.year}</span>
                        </div>
                      ))}
                  </div>
                </div>

                {/* CBSE Section */}
                <div className="board-section">
                  <div className="board-header">
                    <h3>CBSE</h3>
                    <div className="board-underline"></div>
                  </div>
                  <div className="toppers-list">
                    {cbseToppers
                      .sort((a, b) => {
                        if (b.year !== a.year) return b.year - a.year;
                        return rankOrder(a.rank) - rankOrder(b.rank);
                      })
                      .map((student, idx) => (
                        <div className="topper-item" key={student.name + student.year + student.rank + idx}>
                          <span className="student-name" title={student.name}>{student.name}</span>
                          <span className="rank" title={student.rank}>{student.rank}</span>
                          <span className="school" title={student.school}>{student.school}</span>
                          <span className="percentage">{student.percentage}</span>
                          <span className="year">{student.year}</span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              {/* Testimonial Video Section */}
              <div className="video-section">
                <a 
                  href="https://www.youtube.com/watch?v=yAXn6SFOgx0" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="video-container-link"
                >
                  <div className="video-container">
                    <div className="video-light-overlay"></div>
                    <iframe
                      className="testimonial-video"
                      src="https://www.youtube-nocookie.com/embed/yAXn6SFOgx0"
                      title="Student Testimonials"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer"
                    ></iframe>
                    <div className="video-overlay">
                      <div className="overlay-content">
                        <div className="video-title">
                          <h3>Our Achievers Speak</h3>
                          <p>Watch success stories from our toppers</p>
                        </div>
                        <div className="testimonial-stats">
                          <div className="stat-item">
                            <span className="stat-number">99%</span>
                            <span className="stat-label">ICSE Success</span>
                          </div>
                          <div className="stat-divider"></div>
                          <div className="stat-item">
                            <span className="stat-number">98%</span>
                            <span className="stat-label">CBSE Success</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Beyond Academics Section */}
        <section className="beyond-academics-section">
          <div className="container">
            <div className="beyond-academics-content">
              <div className="beyond-academics-text">
                <h2>Beyond Academics</h2>
                <p className="subtitle">Nurturing Holistic Development</p>
                <p className="description">At Biyani's, we believe in developing well-rounded individuals who excel not just in academics but in all aspects of life. Our comprehensive approach focuses on building character, fostering creativity, and developing essential life skills.</p>
              </div>
              <div className="beyond-academics-video">
                <div className="embed-loading">
                  <div className="loading-spinner"></div>
                  <p>Loading content...</p>
                </div>
                <iframe
                  src="https://www.instagram.com/reel/DB-fA_3MlXa/embed"
                  className="instagram-embed"
                  frameBorder="0"
                  allowFullScreen
                  scrolling="no"
                  onLoad={(e) => {
                    e.target.style.opacity = 1;
                    e.target.previousElementSibling.style.display = 'none';
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.previousElementSibling.innerHTML = '<p>Failed to load content. Please check your connection.</p>';
                  }}
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* Julley Section */}
        <section className="julley-section">
          <div className="container">
            <div className="julley-content">
              <h2 className="julley-title">Julley</h2>
              <p className="julley-description">Our Annual Event</p>
              {/* Julley Split View */}
              <JulleySplitView />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

// Carousel component for Julley images
const julleyImages = [
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/1.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/2.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/3.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/4.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/5.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/6.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/7.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/8.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/9.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/10.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/11.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/12.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/15.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/16.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/17.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/18.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/19.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/20.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/21.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/22.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/23.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/24.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/25.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/26.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/27.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/28.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/29.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/30.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/31.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/32.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/33.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/34.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/35.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/36.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/37.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/38.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/39.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/40.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/41.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/42.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/43.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/44.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/45.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/46.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/47.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/48.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/49.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/50.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/51.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/52.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/53.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/54.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/55.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/56.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/57.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/58.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/59.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/60.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/61.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/62.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/63.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/64.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/65.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/66.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/67.JPG',
  '/BIYANIS WEBSITE GALLERY/JULLEY2k24/68.JPG',
];

// Split view component for Julley images
function JulleySplitView() {
  const [start, setStart] = useState(0);
  const total = julleyImages.length;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Swipe support for mobile
  const touchStartX = React.useRef(null);
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;
    if (deltaX > 40) prev();
    else if (deltaX < -40) next();
    touchStartX.current = null;
  };

  const next = () => setStart((start + (isMobile ? 1 : 2)) % total);
  const prev = () => setStart((start - (isMobile ? 1 : 2) + total) % total);

  const img1 = julleyImages[start];
  const img2 = julleyImages[(start + 1) % total];

  return (
    <div className="julley-split-view">
      {/* Desktop arrows (SVG chevrons) */}
      {!isMobile && (
        <button className="split-arrow left" onClick={prev} aria-label="Previous">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#204d7d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
        </button>
      )}
      {isMobile ? (
        <div
          className="split-img"
          style={{backgroundImage: `url('${img1}')`}}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        />
      ) : (
        <>
          <div className="split-img" style={{backgroundImage: `url('${img1}')`}} />
          <div className="split-img" style={{backgroundImage: `url('${img2}')`}} />
        </>
      )}
      {!isMobile && (
        <button className="split-arrow right" onClick={next} aria-label="Next">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#204d7d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
        </button>
      )}
      {/* Mobile: horizontal dots indicator below image */}
      {isMobile && (
        <div className="split-mobile-dots">
          {julleyImages.map((_, idx) => (
            <div
              key={idx}
              className={
                'split-mobile-dot' + (start % total === idx ? ' active' : '')
              }
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default AtBiyanis; 